<template>
  <div class="modelFunctionDiv">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="font-sz24">功能模板管理</span>
        <div class="head-text">
          <el-button type="success" @click="showAddForm(null)"
            >新增模板</el-button
          >
          <el-button type="danger" @click="delAll">删除</el-button>
        </div>
      </div>
      <el-container style="height: 78vh">
        <!-- 这里是侧边栏*-->
        <div class="mar-top20">
          <el-aside width="200px" class="elAside">
            <zTree
              style="height: 612px"
              :zNodes="zNodes"
              @getData="getData"
              @dropTree="dropTree"
              @addZtree="addZtree"
              @delZtree="delZtree"
              @EditName="EditName"
              :options="{
                id: 'fctm01',
                pid: 'fctm03',
                label: 'fctm02',
                zTreeId: 'PdeptTree',
                delType: {
                  add: true,
                  update: true,
                  del: true,
                },
              }"
              ref="zTree"
            />
          </el-aside>
        </div>
        <el-main>
          <div class="rygl-table">
            <el-table
              height="70vh"
              align="center"
              class="table"
              :data="functionList"
              @selection-change="checkChange"
            >
              <el-table-column
                align="center"
                type="selection"
                width="55"
              ></el-table-column>
              <el-table-column
                align="center"
                type="index"
                label="序号"
                width="80"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="fmtp03"
                label="模版名称"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="tempName"
                label="所属模块"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="name"
                label="创建人"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="fmtp06"
                label="创建时间"
              ></el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    @click="showAddForm(scope.row)"
                    size="small"
                    type="primary"
                    plain
                    >编辑</el-button
                  >
                  <el-popconfirm
                    @confirm="DelOneFormTemp(scope.row.fmtp01)"
                    title="确定删除吗？"
                    style="margin-left: 10px"
                  >
                    <el-button slot="reference" size="small" type="danger" plain
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mar-top20"
              align="center"
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="pageIndex"
              :page-sizes="[10, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </el-main>
        <!-- 新增功能模块弹窗 -->
        <ability ref="ability" @signStatusVerdict="listDataStatus"></ability>
      </el-container>
    </el-card>
  </div>
</template>
<script>
import zTree from "@/components/zTree";
import ability from "@/components/ability";
import {
  GetFunctionTemplate,
  AddOrUpdateFunctionTemplate,
  DropFunctionTemplate,
  DelFunctionTemplate,
  GetFormTempLists,
  DelOneFormTemps,
} from "@/setAxios.js";
export default {
  components: { zTree, ability },
  name: "modelFunction",
  props: {},
  data() {
    return {
      zNodes: null,
      functionList: [
        {
          date: "111",
        },
      ],
      searchword: "",
      pageIndex: 1,
      pageSize: 10,
      functempIds: null,
      total: 0,
      ids: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 打开功能模板
    showAddForm(data) {
      if (data) {
        this.$refs.ability.Id = data.fmtp01;
        this.$refs.ability.Admin = data.fmtp07;
      } else {
        this.$refs.ability.Id = null;
        this.$refs.ability.Admin = null;
      }
      this.$refs.ability.open();
    },
    // 获取模板id
    getData(id) {
      this.functempIds = id;
      this.GetFormTempLists();
    },
    async addZtree(id) {
      let params = {
        fctm01: 0,
        fctm02: "新建模板",
        fctm03: id,
        fctm04: 1,
        fctm05: new Date(),
      };
      let res = await AddOrUpdateFunctionTemplate(params);
      this.$message({
        message: "新建成功",
        type: "success",
      });
      this.$refs.zTree.add(res);
    },
    delZtree(ids) {
      DelFunctionTemplate({ ids: ids }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.getInit();
        }
      });
    },
    async EditName(id, name, pid) {
      let params = {
        fctm01: id,
        fctm02: name,
        fctm03: pid,
      };
      let fd = new FormData();
      for (var key in params) {
        fd.append(key, params[key]);
      }

      let res = await AddOrUpdateFunctionTemplate(fd);
      this.$message({
        message: "修改成功",
        type: "success",
      });
      this.getInit();
    },
    dropTree(data) {
      DropFunctionTemplate(data).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "移动成功",
          });
          this.getInit();
        }
      });
    },
    getInit() {
      // 超管端
      GetFunctionTemplate().then((res) => {
        this.zNodes = res.Data.allfunctiontemplates;
      });
      this.GetFormTempLists();
    },
    // 删除模板
    DelOneFormTemp(id) {
      let params = {
        id,
      };
      DelOneFormTemps(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.GetFormTempLists();
        }
      });
    },
    GetFormTempLists() {
      let params = {
        searchword: this.searchword,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        functempIds: this.functempIds,
      };
      GetFormTempLists({ params }).then((res) => {
        if (res.Code > 0) {
          this.functionList = res.Data.list;
          this.total = res.Data.total;
        }
      });
    },
    checkChange(data) {
      this.ids = data.map((v) => v.fmtp01);
    },
    delAll() {
      if (!this.ids) {
        this.$message.error("请选择数据");
        return;
      }
      this.$confirm("此操作将永久删除所选模板, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var i = 0;
        this.ids.forEach((v) => {
          i++;
          DelOneFormTemps({ id: v });
        });
        if (i == this.ids.length) {
          this.$message.success("删除成功！");
          setTimeout(() => {
            this.GetFormTempLists();
          }, 500);
        }
      });
    },
    //子组件中刷新父
    listDataStatus() {
      this.getInit();
    },
    handleSizeChange2(pagesize) {
      this.pageSize = pagesize;
      this.GetFormTempLists();
    },
    handleCurrentChange2(pageindex) {
      this.pageIndex = pageindex;
      this.GetFormTempLists();
    },
  },
  created() {},
  mounted() {
    this.getInit();
  },
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.modelFunctionDiv {
}
//新增
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.mar-top20 {
  margin-top: 20px;
}
.elAside {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
  height: 750px;
}
#PdeptTree {
  height: 500px;
}
.zTreeDiv {
  overflow: auto;
}
.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}
</style>
